<script>
export default {
  name: 'ModelBindingMixin',
  props: {
    /**
     * Model binding property
     */
    value: {
      required: true
    },
    /**
     * Force setting value to default one
     */
    forceDefaultValue: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  /**
   * Vue Model Binding Properties
   */
  model: {
    prop: 'value',
    event: 'update:value'
  },
  computed: {
    /**
     * Model value getter and setter
     */
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('update:value', value)
      }
    }
  },
  watch: {
    /**
     * Update value to default value if provided
     */
    forceDefaultValue: {
      handler (force) {
        if (force && this.model === null && this.defaultValue !== undefined) {
          this.$set(this, 'model', this.defaultValue)
        }
      },
      immediate: true
    }
  }
}
</script>
